// import * as React from "react";

// import { cn } from "@/lib/utils/utils";

// const Input = React.forwardRef<
//   HTMLInputElement,
//   React.InputHTMLAttributes<HTMLInputElement>
// >(({ className, type, ...props }, ref) => {
//   return (
//     <input
//       type={type}
//       className={cn(
//         "flex h-10 w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
//         className
//       )}
//       ref={ref}
//       {...props}
//     />
//   );
// });
// Input.displayName = "Input";

// export { Input };

import * as React from "react";

import { cn } from "@/lib/utils/utils";

//Here noBlur is used to prevent the trim and onChange event on focus out. Which is our default behavior.
const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & {
    noBlur?: boolean;
  }
>(({ className, type, onKeyDown, onBlur, noBlur = false, ...props }, ref) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent double spaces
    if (e.key === " ") {
      const input = e.currentTarget;
      const cursorPosition = input.selectionStart;
      if (
        cursorPosition === 0 ||
        (cursorPosition && input.value[cursorPosition - 1] === " ")
      ) {
        e.preventDefault();
      }
    }

    // Call the passed onKeyDown handler if it exists
    onKeyDown?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const trimmedValue = e.target.value.trim();
    if (props.onChange) {
      const event = {
        ...e,
        target: { ...e.target, value: trimmedValue },
      } as React.ChangeEvent<HTMLInputElement>;
      props.onChange(event);
    }

    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <input
      type={type}
      onKeyDown={handleKeyDown}
      onBlur={noBlur ? undefined : handleBlur}
      className={cn(
        "flex h-10 w-full rounded-md border border-input px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
